import styled from "styled-components";
import bgIcons from '../../../../assets/pages/NewHome/bgIcons.svg';
import circle from '../../../../assets/pages/NewHome/circle.svg';

export const Wrapper = styled.div`
  position: relative;


  display: block;
  background: white;


  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    min-height: 600px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
     margin: -48px -48px 0 -48px;


    background: linear-gradient(
      180deg,
      rgba(244, 248, 255, 1) 0%,
      rgba(255, 255, 255, 0) 30%,
      rgba(255, 255, 255, 0) 60%,
      rgba(244, 250, 255, 1) 100%
    );

    z-index: 1;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 40vw;
      bottom: 0;
      width: 100vw;
      background: url(${bgIcons}) no-repeat;
      background-size: contain;
      -webkit-background-size: contain;
      z-index: 0;
      opacity: 0.15;
      pointer-events: none;
      will-change: transform;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tabletLg}) {
    margin: -48px -48px 0 -48px;
  }
`;

export const ContentWrapper = styled.div`
  width: 100%;
  padding: 0 16px;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    max-width: 40%;
    padding-left: 48px;
    margin-top: 24px;
  }
`;

export const MainTitle = styled.h1`
  font-size: ${32 / 16}rem;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.primary.blue900};
  font-family: "Plus Jakarta Sans";

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: ${42 / 16}rem;
  }
`;

export const MainParagraph = styled.p`
  margin-top: 24px;
  font-size: ${14 / 16}rem;
  line-height: ${24 / 16}rem;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.greyscale.grey300};
  font-family: "Mulish";

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: ${16 / 16}rem;
  }
`;

export const VideoWrapper = styled.div`
  display: none;
  max-width: 480px;
  height: auto;
  object-fit: contain;
  aspect-ratio: 3 / 2;

  & img {
      width: 100%;
      max-width: 100%;
      height: auto;
      max-height: 400px;
      z-index: 1;
      display: block;
    }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    margin-top: 100px;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1;
    height: 100%; 
    
    & img {
      width: 100%;
      max-width: 100%;
      height: auto;
      max-height: 460px;
      z-index: 1;
      display: block;
      transform: translateY(-30px)
    }


    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 360px;
      background: url(${circle}) no-repeat center;
      background-size: contain;
      -webkit-background-size: contain;
      z-index: 0;
      pointer-events: none;
      overflow: visible;
      transform: translateY(-96px) translateX(50px);
      will-change: transform;
      height: auto;
      max-width: 100%;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tabletLg}) {

    & img {
      max-height: 480px;
      object-fit: contain;
      transform: translateY(-40px);
      overflow: hidden;
    }

    &::before {
      width: 440px;
      transform: translateY(-90px) translateX(10px);
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    right: 81px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktopTxl}) {
    right: 81px;
  }

`;
